import React, { useState } from 'react'
import styles from '../../styles/aPOS/androidPOS.module.css';
import ReactTyped from 'react-typed';
import Image from 'next/image';
import { BlackCustomButton, MarqueeComponentHomePage, TransparentCustomButton } from '../qbStrap';
import content from '../../language/ENGLISH.json'
import { ClientsArr1, androidFAQ, testimonialData, videoTestimonial , getTitleContent } from '@/constants/common';
import { workingStructure } from '@/constants/mpos';
import IndustryFeatures from '../common/IndustryFeatures';
import { features } from '@/constants/industry';
import InfoBanner from '../enterprise/InfoBanner';
import { OurPartners } from '../homePage/OurPartners';
import ThreeStepForm from '../common/ThreeStepForm';
import TrustFactor from '../common/TrustFactor';
import FrequentQuestions from '../homePage/FrequentQuestions';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import VerificationPopup from '../modals/VerificationPopup';
import { useRouter } from 'next/router';
import { IoMdArrowRoundForward } from "react-icons/io";
import Link from 'next/link';

const DesktopAPOS = () => {
    // ------constants------
    // const windowVsAndroid = [
    //     {
    //         icon: "/assets/androidPOS/hardware.svg",
    //         bgColor: "#EDFBFE",
    //         title: <>Cost of Hardware</>,
    //         window: "Hardware required to run such software is costly. A laptop/desktop is required along with a lot of other peripheral devices.",
    //         android: "Hardware required to run QueueBuster is highly cost effective. Literally a smartphone is enough to run the entire store with ease"
    //     },
    //     {
    //         icon: "/assets/androidPOS/software.svg",
    //         bgColor: "#FFF6E4",
    //         title: <>Cost of software</>,
    //         window: <>Windows-based legacy <Link className='linked_text' href="https://queuebuster.co/features/erp-software">ERP software</Link> are expensive and comes with a lot of overhead expenses and AMCs.</>,
    //         android: "QueueBuster SaaS software is extremely feature-rich yet very affordable. You can even start/stop the SaaS subscription anytime you want."
    //     },
    //     {
    //         icon: "/assets/androidPOS/shelf-space.svg",
    //         bgColor: "#FFF3F3",
    //         title: <>Retail shelf space</>,
    //         window: "Bulky devices take a lot of shelf space. In some cases, more than 20% shelf space is consumed just to put a windows-based machine. Expensive real estate is wasted.",
    //         android: "Android-based devices are highly space efficient. From smartphones, credit card machines & handheld devices to full size terminals, Android devices are truly space efficient."
    //     },
    //     {
    //         icon: "/assets/androidPOS/ease-of-use.svg",
    //         bgColor: "#EDFEF9",
    //         title: <>Ease of use</>,
    //         window: "Most windows-based software are complicated and requires a lot of training.",
    //         android: "Very less training required. Extremely easy-to-use & intuitive software reduces the training time drastically."
    //     },
    //     {
    //         icon: "/assets/androidPOS/e-waste.svg",
    //         bgColor: "#FCF5FF",
    //         title: <>e-Waste</>,
    //         window: "Laptop/Desktop devices along with multiple peripheral accessories generate a lot of e-Waste.",
    //         android: "Over 80% reduction in e-Waste because of less electronics being deployed."
    //     },
    //     {
    //         icon: "/assets/androidPOS/integration.svg",
    //         bgColor: "#EDFBFE",
    //         title: <>3rd Party Integrations</>,
    //         window: "Not integrated with other leading software. Most of these software work in silos",
    //         android: "Integrated with 25+ software like Tally, Zoho, Microsoft Navision etc. for smooth HQ operations"
    //     },
    //     {
    //         icon: "/assets/androidPOS/omnichannel.svg",
    //         bgColor: "#FFF6E4",
    //         title: <>Omnichannel Software</>,
    //         window: "Doesn’t provide complete omnichannel features to manage your business both online & offline.",
    //         android: "Truly omnichannel software to help you scale your business both offline as well as online."
    //     },
    //     {
    //         icon: "/assets/androidPOS/users.svg",
    //         bgColor: "#EDFEF9",
    //         title: <>Number of Users</>,
    //         window: "Limited number of users are allowed to use the software",
    //         android: "Unlimited number of users are allowed. We only charge for per device installation"
    //     },
    //     {
    //         icon: "/assets/androidPOS/cloud.svg",
    //         bgColor: "#FFF3F3",
    //         title: <>Cloud Storage</>,
    //         window: "In most cases, cloud storage is charged additionally to keep the merchants’ data online.",
    //         android: "Cloud dashboard is absolutely FREE. A lot of bulk operations and a plethora of reports are also available on the cloud dashboard."
    //     },
    //     {
    //         icon: "/assets/androidPOS/cost.svg",
    //         bgColor: "#FCF5FF",
    //         title: <>Cost of Trials</>,
    //         window: "Requires a lot of investment to even start using the software",
    //         android: <>Can literally test the software on smartphones or <Link className='linked_text' href="https://queuebuster.co/pos-hardware-partners">Android-based card swiping machines</Link> before investing huge sums of money.</>
    //     },
    //     {
    //         icon: "/assets/androidPOS/tech-support.svg",
    //         bgColor: "#EDFBFE",
    //         title: <>24x7 Tech Support</>,
    //         window: "Do not offer 24x7 support / have costly support plans.",
    //         android: "24x7 tech support provided."
    //     },
    // ]
    const windowVsAndroid = [
        {
            icon: "/assets/androidPOS/hardware.svg",
            bgColor: "#EDFBFE",
            title: <>Cost of Hardware</>,
            window: "High (Laptop/Desktop + Peripherals)",
            android: "Low (Smartphone)"
        },
        {
            icon: "/assets/androidPOS/software.svg",
            bgColor: "#FFF6E4",
            title: <>Cost of software</>,
            window: <>Expensive, Fixed Cost</>,
            android: "Affordable, Scalable Subscription."
        },
        {
            icon: "/assets/androidPOS/shelf-space.svg",
            bgColor: "#FFF3F3",
            title: <>Retail shelf space</>,
            window: "Bulky (Windows Machines)",
            android: "Minimal (Android Devices)"
        },
        {
            icon: "/assets/androidPOS/ease-of-use.svg",
            bgColor: "#EDFEF9",
            title: <>Ease of use</>,
            window: "Complex, Requires Training",
            android: "Easy, Intuitive"
        },
        {
            icon: "/assets/androidPOS/e-waste.svg",
            bgColor: "#FCF5FF",
            title: <>e-Waste</>,
            window: "High",
            android: "Low"
        },
        {
            icon: "/assets/androidPOS/integration.svg",
            bgColor: "#EDFBFE",
            title: <>3rd Party Integrations</>,
            window: "Limited Integrations",
            android: "25+ Leading Software"
        },
        {
            icon: "/assets/androidPOS/omnichannel.svg",
            bgColor: "#FFF6E4",
            title: <>Omnichannel Software</>,
            window: "No",
            android: "Yes"
        },
        {
            icon: "/assets/androidPOS/users.svg",
            bgColor: "#EDFEF9",
            title: <>Number of Users</>,
            window: "Limited",
            android: "Unlimited (Per Device)"
        },
        {
            icon: "/assets/androidPOS/cloud.svg",
            bgColor: "#FFF3F3",
            title: <>Cloud Storage</>,
            window: "Additional Charge",
            android: "Free"
        },
        {
            icon: "/assets/androidPOS/cost.svg",
            bgColor: "#FCF5FF",
            title: <>Cost of Trials</>,
            window: "High Investment",
            android: "Low (Smartphone Trial)"
        },
        {
            icon: "/assets/androidPOS/tech-support.svg",
            bgColor: "#EDFBFE",
            title: <>24x7 Tech Support</>,
            window: "Limited/Costly Plans",
            android: "24/7 Free"
        },
    ]

    const { commonMarqueTitle } = getTitleContent();
    const { workHeading, moreThanPOS, allInOneSoln, faqHeading } = content.mpos
    const router = useRouter();

    const [step, setStep] = useState({
        title: 'Easy Setup',
        img: '/assets/mPOS/easy-setup.webp',
        imgHeight: '40rem',
        imgWidth: '35rem',
    });
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                <div className={styles.text_container}>
                    <h1>
                        <span className={styles.black_text}>Smart Android POS Billing App Enhancing</span><br />
                        <span className={styles.blue_text}><ReactTyped strings={["Bulk Operations", "Integration", "Mobility", "Scalability"]} typeSpeed={200} loop /></span>
                    </h1>
                    <p className={styles.page_desc}>QueueBuster POS billing app takes on the conventional billing solutions through customizable intricacies and real time insights, enabling faster checkouts on any Android device.</p>
                    <div style={{ display: "flex", gap: "2rem" }}>
                        <button className={'light_blue_solid_btn'} style={{ marginTop: "2rem" }}>Try It Free</button>
                    </div>
                </div>
            </div>

            <div className={styles.marquee_section}>
                <div className={styles.section_heading}><h3>{commonMarqueTitle}</h3><div className={styles.heading_stroke} style={{ width: '22rem' }}><Image src='/assets/industry/restaurant/features_hl.svg' alt='stroke' fill /></div></div>
                <MarqueeComponentHomePage ClientsArr={ClientsArr1} />
            </div>
            <div className={styles.collab}>
                <div>
                    <h3>Know The Android Advantage Beyond Point of Sale</h3>
                    <ul>
                        <li>An Android POS billing app provides the convenience of portability, allowing businesses to conduct transactions anywhere, anytime, enhancing customer service and flexibility.</li>
                        <li>Android POS billing app offers quick app updates, ensuring businesses have access to the latest features, security patches, and improvements for enhanced performance and reliability.</li>
                        <li>Businesses can customize their experience with Android POS billing app, tailoring settings, layouts, and functionalities to suit their specific needs and preferences, enhancing efficiency and user satisfaction.</li>
                    </ul>
                    <p onClick={() => (setDemoModal(true),
                        setHeading("Our Product Experts will call you soon!")
                    )}>Talk to us now <IoMdArrowRoundForward />
                    </p>
                </div>
                <div className={styles.pos_image}><Image src="/assets/androidPOS/android-bluefold.webp" alt="Beyond Just Point of Sale" fill /></div>
            </div>

            <div className={styles.working_section}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}><h4 className={styles.working_section_heading}>{workHeading}</h4> <div className={styles.work_stroke}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='features' fill /></div></div>
                <div className={styles.work_container}>
                    <div className={styles.working_content}>
                        <h4>{moreThanPOS}</h4>
                        <p>{allInOneSoln}</p>
                        <div style={{ display: 'flex', marginTop: '3rem' }}>
                            <div className={styles.working_timeline}>
                                {
                                    workingStructure?.map((ele) => {
                                        return (
                                            <div key={ele?.id} onClick={() => setStep({ title: ele?.title, img: ele?.img, imgHeight: ele?.imgHt, imgWidth: ele?.imgWt })}></div>
                                        )
                                    })
                                }
                            </div>
                            <div>
                                {
                                    workingStructure?.map((ele) => {
                                        return (
                                            <div key={ele?.id} className={`${ele?.title === step?.title ? styles.timeline_display : styles.timeline_content}`}>
                                                <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }}>
                                                    {
                                                        step?.title != ele?.title ?
                                                            <div className={styles.inner_icon}><Image src={ele?.icon2} alt='easy steps' fill /></div>
                                                            : <div className={styles.step_icon}><Image src={ele?.icon} alt='easy steps' fill /></div>
                                                    }
                                                    <div>
                                                        <h4 onClick={() => setStep({ ...step, title: ele?.title, img: ele?.img, imgHeight: ele?.imgHt, imgWidth: ele?.imgWt })}>{ele?.title}</h4>
                                                        <p className={`${step?.title != ele?.title && styles.hide}`}>{ele?.desc}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.working_img_container}>
                        <div style={{ height: step?.imgHeight, width: step?.imgWidth, position: 'relative' }}><Image src={step?.img} alt='' fill /></div>
                    </div>
                </div>
            </div>

            <div className={styles.benefits_APOS}>
                <div className={styles.top_stack}>
                    <h3>Boost Your Business with an Android POS System</h3>
                    <ul className={styles.benefits_list}>
                        <li><b>Versatile Compatibility</b><br />
                            <p>QB POS works seamlessly with any Android device or peripherals, providing flexibility for different business setups.</p>
                        </li>
                        <li>
                            <b>Affordability</b><br />
                            <p>QueueBuster can save overhead expenditure as Android devices are generally more budget-friendly than traditional <Link className='linked_text' href="https://queuebuster.co/pos-hardware-partners">POS machines.</Link></p>
                        </li>
                        <li>
                            <b>Intuitive Interface</b><br />
                            <p>Manage, monitor and map all your business processes with the most user friendly and versatile interface.</p>
                        </li>
                        <li>
                            <b>Mobility</b><br />
                            <p> Own the convenience of a <Link className='linked_text' href="https://queuebuster.co" target='_n'>Cloud based POS solution</Link> right at your finger tips, anytime, anywhere.</p>
                        </li>
                    </ul>
                    <BlackCustomButton text="Get In Touch" style={{ padding: "0 2rem", marginTop: "2rem" }} onClick={() => (setDemoModal(true), setHeading("Book your free demo now!"))} />
                    <div className={styles.APOS_machine}><Image src="/assets/hardware/APOS.webp" alt="Android POS system" fill /></div>
                </div>
                <div className={styles.mid_stack}></div>
                <div className={styles.last_stack}></div>
            </div >

            <div className={styles.difference_section}>
                <div className={styles.features_header}><h4>Windows VS Android</h4><div className={styles.features_stroke}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <div>
                    <div className={styles.heading_container}>
                         <h5>QueueBuster</h5>
                        <h5>Features</h5>
                        <h5>Windows-Based Software</h5>
                    </div>
                    {
                        windowVsAndroid?.map((ele) => {
                            return (
                                <div className={styles.difference_container} >
                                     <div style={{textAlign:'center', alignContent:'center'}}>
                                        <p>{ele?.android}</p>
                                    </div>
                                    <div style={{ display: "flex", gap: "2rem", justifyContent: "center", alignItems: "center", backgroundColor: ele?.bgColor, padding: "1.5rem"}}>
                                        <div style={{display: "flex", alignItems: "center",gap: "1rem" }}>
                                            <div style={{ height: "3rem", width: "3rem", position: "relative" }}>
                                                <Image src={ele?.icon} alt={ele?.title} fill />
                                            </div>
                                            <h4 style={{ margin: 0 }}>{ele?.title}</h4>
                                        </div>
                                    </div>

                                    <div style={{textAlign:'center',alignContent:'center'}}>
                                        <p>{ele?.window}</p>
                                    </div>
                                     
                                     
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            <div className={styles.features_section}>
                <div className={styles.features_header}><h4>Other Features</h4><div className={styles.features_stroke}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <IndustryFeatures features={features} cardMaxHeight="25rem" />
            </div>
            <InfoBanner />
            <OurPartners title={"Partners and Integrations"} />
            <div style={{ margin: "0rem 9.3rem 7rem 9.3rem" }}>
                <ThreeStepForm
                    heading={<>3 Easy Steps <br />to Start Your Billing</>}
                    desc={"Our Android-based billing software runs seamlessly on any Android device, be it a mobile phone, tablet, or desktop, tailored to your business needs. Just follow these basic steps with no complex training required, and start managing your business efficiently."}
                />
            </div>
            <div className={styles.testimonial_section}>
                <div className={styles.testimonial_header}><h3>{"Don't Take Our Word For It!"}</h3> <div className={styles.testimonial_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
            </div>
            <TrustFactor />
            <FrequentQuestions FaqTableData={androidFAQ} heading={"FAQs for Android POS Billing App"} />
            <div className={styles.demo_banner_section}>
                <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            </div>
        </>
    )
}

export default DesktopAPOS